import React, { useEffect, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CorrectExregular12() {
  const Navigate = useNavigate();
  const {
    setCandidateid12,
    setCastecode12,
    setDivyangcode12,
    candidateid12,
    mode12,
    setMode12,
    setDocverify12,
    class12regulardata,
  } = useContext(ContextBoard);
  const location = useLocation();
  const { studentData } = location.state || {};
  // console.log("studentData:", studentData.candidatE_ID);

  const [religionList, setReligionList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [formData, setFormData] = useState({
    passingyear: "",
    roll_code: "",
    roll_number: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "",
    faculty: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    elective_subject: "",
    language_one_code: "",
    language_two_code: "",
    compulsory_one_code: "",
    compulsory_two_code: "",
    compulsory_three_code: "",
    additional_subject_code: "",
    elective_subject_code: "",
    apaar_id: "",
    pen_no: "",
    section: "",
    reg_session: "",
    exam_medium: "",
  });
  const [fieldsMissing, setFieldsMissing] = useState({
    religion: false,
    caste: false,
  });
  useEffect(() => {
    if (!studentData) {
      Navigate("/class-xii-dashboard");
      return;
    } else {
      setFieldsMissing({
        religion: !studentData.religion,
        caste: !studentData.caste,
      });
    }
  }, [Navigate]);
  useEffect(() => {
    setLoading(true);
    if (mode12 === "edit") {
      setFinaledit(true);
      setIsEditMode(true);
      setIsPreviewed(true);
    }

    const religionList = getSessionData("religionList") || [];
    const castelist = getSessionData("casteList") || [];
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setCasteList(Array.isArray(castelist) ? castelist : []);

    setFormData((prev) => ({
      ...prev,
      passingyear: studentData.cL_12_EXAM_YEAR || "",
      roll_code: sessionStorage.getItem("schoolCode"),
      roll_number: studentData.rolL_NO || "",
      registration_number: studentData.registratioN_ID_CL_12 || "",
      candidate_name: studentData.candidatE_NAME || "",
      gender: studentData.gender || "",
      date_of_birth: studentData.dob || "",
      fathers_name: studentData.fatheR_NAME || "",
      mothers_name: studentData.motheR_NAME || "",
      religion: studentData.religion || "",
      nationality: studentData.nationality || "",
      aadhaar_no: studentData.aadhaR_CARD || "",
      divyang_val: studentData.divyang || "",
      caste_val: studentData.caste || "",
      area: studentData.area || "",
      state_val: studentData.state || "",
      district_val: studentData.districT_ID || "",
      block_val: studentData.block || "",
      address_val: studentData.address || "",
      pin_no: studentData.pincode || "",
      contact_no: studentData.contacT_NO || "",
      email_id: studentData.emaiL_ID || "",
      category_choice: studentData.studenT_EXAM_SUB_CATEGORY || "",
      board_name: studentData.board || "",
      faculty: studentData.faculty
        ? studentData.faculty
        : studentData.stream
        ? studentData.stream
        : "",
      language_one: studentData.subjecT_NAME1 || "",
      language_two: studentData.subjecT_NAME2 || "",
      compulsory_one: studentData.subjecT_NAME3 || "",
      compulsory_two: studentData.subjecT_NAME4 || "",
      compulsory_three: studentData.subjecT_NAME5 || "",
      additional_subject: studentData.subjecT_NAME6 || "",
      elective_subject: studentData.subjecT_NAME7 || "",
      language_one_code: studentData.suB_1 || "",
      language_two_code: studentData.suB_2 || "",
      compulsory_one_code: studentData.suB_3 || "",
      compulsory_two_code: studentData.suB_4 || "",
      compulsory_three_code: studentData.suB_5 || "",
      additional_subject_code: studentData.suB_6 || "",
      elective_subject_code: studentData.suB_7 || "",
      apaar_id: studentData.apaaR_ID || "",
      pen_no: studentData.peN_NO || "",
      section: studentData.section || "",
      reg_session: studentData.registratioN_SESSION_CL_12 || "",
      exam_medium: studentData.mediuM_OF_EXAM || "",
    }));

    setLoading(false);
  }, []);

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const newErrors = {};

    // if (fieldsMissing.religion && !formData.religion) {
    //   newErrors.religion = "Religion is required.";
    // }
    // if (fieldsMissing.caste && !formData.caste) {
    //   newErrors.caste = "Caste is required.";
    // }
    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleButtonClick = () => {
    // const isEditMode = mode12;
    // if (isEditMode === "edit") {
    handleEditSubmit();
    // } else {
    //   handleSubmit();
    // }
  };
  const handleEditSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassxii");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid12(studentData.candidatE_ID || "");
    setCastecode12(formData.caste_val || "");
    setDivyangcode12(formData.divyang_val || "");
    setDocverify12(false);
    setMode12("edit");
    Navigate("/class-xii-upload-document", {
      state: {
        candidateId: studentData.candidatE_ID || "",
        referenceNo: studentData.registratioN_ID_CL_11 || "",
      },
    });
    // const payload = {
    //   candidatE_CODE: candidateid12,
    //   religion: formData.religion || "",
    // };
    // try {
    //   const response = await fetch(
    //     `${config.API_BASE_URL}/UpdateEXRegularStudentRegistration_CL12`,
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //       body: JSON.stringify(payload),
    //     }
    //   );

    //   const data = await response.json();

    //   if (response.ok) {
    //     setCandidateid12(candidateid12 || "");
    //     setCastecode12(formData.caste_val || "");
    //     setDivyangcode12(formData.divyang_val || "");
    //     await Swal.fire({
    //       icon: "success",
    //       title: "Success",
    //       text: "Your data Updated successfully",
    //       confirmButtonText: "OK",
    //     });
    //     // setCandidateData({});
    //     if (finaledit === false) {
    //       setDocverify12(true);
    //       Navigate("/class-xii-upload-document");
    //     } else {
    //       Navigate("/class-xii-upload-document");
    //     }

    //     // window.location.reload();
    //   } else {
    //     await Swal.fire({
    //       icon: "error",
    //       title: "Submission Failed",
    //       text: data.message || "Something went wrong. Please try again.",
    //     });
    //   }
    // } catch (error) {
    //   console.error("API Error:", error);
    //   await Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: error?.message || "Something went wrong. Please try again later.",
    //   });
    // }
  };
  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid12(candidateid12 || "");
    setCastecode12(formData.caste_val || "");
    setDivyangcode12(formData.divyang_val || "");
    if (finaledit === false) {
      setDocverify12(true);
      Navigate("/class-xii-upload-document");
    } else {
      Navigate("/class-xii-upload-document");
    }
  };
  const handleChange = (e) => {
    const { name, value = "" } = e.target;
    let formattedValue = value;

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };
  return (
    <>
      <div class="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar12 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Correct Ex-Regular
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student (JAC)</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    class="form-control form-control-sm disable count"
                                    name="candidate_name"
                                    value={formData.candidate_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.gender}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Date of Birth</label>
                                <DatePicker
                                  id="birth_date"
                                  name="birth_date"
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd)
                                          );
                                        })()
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const dd = String(
                                        date.getDate()
                                      ).padStart(2, "0");
                                      const mm = String(
                                        date.getMonth() + 1
                                      ).padStart(2, "0");
                                      const yyyy = date.getFullYear();

                                      setFormData({
                                        ...formData,
                                        date_of_birth: `${dd}-${mm}-${yyyy}`, // store dd-mm-yyyy
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        date_of_birth: "",
                                      });
                                    }
                                  }}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control form-control-sm disable"
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  // maxDate={new Date("2013-03-01")}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Father’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="father_name"
                                    disabled
                                    class="form-control form-control-sm disable count1"
                                    value={formData.fathers_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Mother’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mother_name"
                                    disabled
                                    class="form-control form-control-sm disable count2"
                                    value={formData.mothers_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Religion
                                  {/* {fieldsMissing.religion && (
                                    <span class="text-danger">&nbsp;*</span>
                                  )} */}
                                </label>
                                <select
                                  className={`form-select form-select-sm ${
                                    errors.religion ? "is-invalid" : ""
                                  }`}
                                  name="religion"
                                  // disabled
                                  id="religion"
                                  onChange={handleChange}
                                  value={formData.religion || ""}
                                  disabled
                                >
                                  <option value="">Select</option>
                                  {religionList.map((religion) => (
                                    <option
                                      key={religion.religioN_ID}
                                      value={religion.religioN_ID}
                                    >
                                      {religion.religioN_NAME}
                                    </option>
                                  ))}
                                </select>
                                {/* {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Caste
                                  {/* {fieldsMissing.caste && (
                                    <span class="text-danger">&nbsp;*</span>
                                  )} */}
                                </label>
                                <select
                                  className={`form-select form-select-sm ${
                                    errors.caste ? "is-invalid" : ""
                                  }`}
                                  name="caste"
                                  // disabled
                                  id="caste"
                                  onChange={handleChange}
                                  value={formData.caste_val || ""}
                                  disabled
                                >
                                  <option value="">Select</option>
                                  {casteList.map((caste) => (
                                    <option
                                      key={caste.castE_ID}
                                      value={caste.castE_ID}
                                    >
                                      {caste.castE_NAME}
                                    </option>
                                  ))}
                                </select>
                                {/* {errors.caste && (
                                  <div className="text-danger mt-1 small">
                                    {errors.caste}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.nationality}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Area</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.area}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>
                                <input
                                  type="name"
                                  class="form-control form-control-sm"
                                  value={formData.category_choice}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>

                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  value={formData.board_name}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label>Stream</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  value={formData.faculty}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12 mb-3" id="paper1">
                              <h4>Core Subjects</h4>
                              <hr />
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group mb-3">
                                    <label>Core Language</label>
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      value={
                                        formData.language_one &&
                                        formData.language_one_code
                                          ? `${formData.language_one} (${formData.language_one_code})`
                                          : ""
                                      }
                                      // value={formData.language_one}
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group mb-3">
                                    <label>Matri Bhasa</label>
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      // value={formData.language_two}
                                      value={
                                        formData.language_two &&
                                        formData.language_two_code
                                          ? `${formData.language_two} (${formData.language_two_code})`
                                          : ""
                                      }
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {formData.faculty === "SCIENCE" && (
                              <>
                                <div class="col-md-12 mb-3" id="science_paper2">
                                  <h4>Compulsory Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 1</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_one &&
                                            formData.compulsory_one_code
                                              ? `${formData.compulsory_one} (${formData.compulsory_one_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_one}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 2</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_two &&
                                            formData.compulsory_two_code
                                              ? `${formData.compulsory_two} (${formData.compulsory_two_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_two}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 mb-3" id="science_paper3">
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 1</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_three &&
                                            formData.compulsory_three_code
                                              ? `${formData.compulsory_three} (${formData.compulsory_three_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_three}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 2</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.additional_subject &&
                                            formData.additional_subject_code
                                              ? `${formData.additional_subject} (${formData.additional_subject_code})`
                                              : ""
                                          }
                                          // value={formData.additional_subject}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12" id="science_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4 mb-2">
                                      <div class="form-group mb-3">
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.elective_subject &&
                                            formData.elective_subject_code
                                              ? `${formData.elective_subject} (${formData.elective_subject_code})`
                                              : ""
                                          }
                                          // value={formData.elective_subject}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {formData.faculty === "COMMERCE" && (
                              <>
                                <div
                                  class="col-md-12 mb-3"
                                  id="commerce_paper2"
                                >
                                  <h4>Compulsory Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 1</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_one &&
                                            formData.compulsory_one_code
                                              ? `${formData.compulsory_one} (${formData.compulsory_one_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_one}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Compulsory 2</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_two &&
                                            formData.compulsory_two_code
                                              ? `${formData.compulsory_two} (${formData.compulsory_two_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_two}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="col-md-12 mb-3"
                                  id="commerce_paper3"
                                >
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 1</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.compulsory_three &&
                                            formData.compulsory_three_code
                                              ? `${formData.compulsory_three} (${formData.compulsory_three_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_three}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 2</label>
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.additional_subject &&
                                            formData.additional_subject_code
                                              ? `${formData.additional_subject} (${formData.additional_subject_code})`
                                              : ""
                                          }
                                          // value={formData.additional_subject}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12" id="commerce_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4 mb-2">
                                      <div class="form-group mb-3">
                                        <input
                                          disabled
                                          type="text"
                                          class="form-control form-control-sm select-disable"
                                          value={
                                            formData.elective_subject &&
                                            formData.elective_subject_code
                                              ? `${formData.elective_subject} (${formData.elective_subject_code})`
                                              : ""
                                          }
                                          // value={formData.elective_subject}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {formData.faculty === "ARTS" && (
                              <>
                                <div class="col-md-12 mb-3" id="arts_paper2">
                                  <h4>Elective Subject</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Elective Language</label>
                                        <input
                                          type="text"
                                          disabled
                                          class="form-control form-control-sm"
                                          value={
                                            formData.compulsory_one &&
                                            formData.compulsory_one_code
                                              ? `${formData.compulsory_one} (${formData.compulsory_one_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_one}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12 mb-3" id="arts_paper3">
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 1</label>
                                        <input
                                          type="text"
                                          disabled
                                          class="form-control form-control-sm"
                                          value={
                                            formData.compulsory_two &&
                                            formData.compulsory_two_code
                                              ? `${formData.compulsory_two} (${formData.compulsory_two_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_two}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 2</label>
                                        <input
                                          type="text"
                                          disabled
                                          class="form-control form-control-sm"
                                          value={
                                            formData.compulsory_three &&
                                            formData.compulsory_three_code
                                              ? `${formData.compulsory_three} (${formData.compulsory_three_code})`
                                              : ""
                                          }
                                          // value={formData.compulsory_three}
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Optional 3</label>
                                        <input
                                          type="text"
                                          disabled
                                          class="form-control form-control-sm"
                                          // value={formData.additional_subject}
                                          value={
                                            formData.additional_subject &&
                                            formData.additional_subject_code
                                              ? `${formData.additional_subject} (${formData.additional_subject_code})`
                                              : ""
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-12" id="arts_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <div class="col-md-4 mb-2">
                                      <div class="form-group mb-3">
                                        <input
                                          type="text"
                                          disabled
                                          class="form-control form-control-sm"
                                          value={
                                            formData.elective_subject &&
                                            formData.elective_subject_code
                                              ? `${formData.elective_subject} (${formData.elective_subject_code})`
                                              : ""
                                          }
                                          // value={formData.elective_subject}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  // Navigate("/class-xii-total-registration")
                                  setIsPreviewed(false)
                                }
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                                {/* <i class="fa fa-backward me-1"></i> Back */}
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectExregular12;
